﻿import {
	Attachments,
	Drivers,
	ICreateComponentAttachments,
	PermitId,
	Permits,
	Residencies,
	Vehicles
} from "@2d-front-monorepo/permits-business";

import {JSX, useCallback, useMemo} from "react";
import {useNavigate, useParams} from "react-router";
import InvalidPermitId from "../../components/InvalidPermitId";
import UpdateAttachmentsComponent from "../../components/UpdateAttachmentsComponent";
import {getHttpClient} from "../../hooks/getHttpClient";
import {ReloadEntities, reloadPermits} from "../../hooks/reloadPermits";
import {usePermits} from "../../hooks/usePermits";
import {PrivateRoutes} from "../../routes";

export default function UpdateDocumentation(): JSX.Element {
	const {permitId} = useParams<{ permitId: string }>() as { permitId: PermitId };
	const permitsState = usePermits();
	const navigate = useNavigate();
	const permit = Permits.find(permitsState, permitId);

	const initialState = useMemo<ICreateComponentAttachments>(() => ({
		attachments: {}
	}), []);

	const driver = permit == null ? undefined : Drivers.getValid(permitsState, permit.driver);
	const residency = permit == null ? undefined : Residencies.getValid(permitsState, permit.residency);
	const vehicles = useMemo(() => permit == null ? [] : Vehicles.getValid(permitsState, permit.vehicles), [permitsState, permit]);
	const attachments = useMemo(() => Attachments.findExpired([driver?.entity, residency?.entity, ...(vehicles.map(x => x.entity))]), [vehicles, driver?.entity, residency?.entity]);

	const onSubmit = useCallback(async function (): Promise<void> {
		if (permit == null) return;
		await getHttpClient().permits.submitForReview(permit.id);
		await reloadPermits(ReloadEntities.Permits);
		navigate(PrivateRoutes.permitsList);
	}, [permit?.id, navigate]);

	if (permit == null) {
		return <InvalidPermitId permitId={permitId}/>;
	}

	return <UpdateAttachmentsComponent attachments={attachments} onSubmit={onSubmit} initialState={initialState}/>;
}
